/** returns Beneficiaries List
@return { Array }
*/
export const getBeneficiariesList = state => {
    return state.beneficiariesList
}
